import React, { useMemo } from "react";
import { useSelections } from "../../../../hooks/useSelections";
import { usePracticeListFromDSA } from "../../../../service/hooks";
import { memoryCache } from "../../../../service/services/memory-cache.service";
import { usePracticeTable } from "./hooks/usePracticeTable";
import { PracticeRowData, PracticeTable } from "./components/PracticeTable";
import { IConfigSelection, IExecutionConfiguration, IPractice } from "./Types";

interface PracticesProps {
  executionConfiguration: IExecutionConfiguration;
  allowSelection?: boolean;
  dsa: string;
}

export const Practices: React.FC<PracticesProps> = ({ executionConfiguration, allowSelection = false, dsa }) => {
  const  { columns } = usePracticeTable();
  const [selectedRowIds, emit] = useSelections();
  const practicesRequest =  usePracticeListFromDSA(dsa);
  const handleSelectionChange = (selectedRows): void => {
    const rows = selectedRows.map(row => row.id);
    memoryCache.set<IConfigSelection>("entitySelection", { ids: rows, type: executionConfiguration.typeValue });
    emit(rows);
  };

  const practices: IPractice[] = useMemo(() => {
    if(executionConfiguration) {
      const dsaPractices = executionConfiguration.dsa?.practices;
      if (Array.isArray(dsaPractices) && dsaPractices.length > 0) {
        return dsaPractices;
      }

      const cdbPractices = executionConfiguration.cdb?.practices;
      if (Array.isArray(cdbPractices) && cdbPractices.length > 0) {
        return cdbPractices;
      }
    }

    if (dsa.trim().length > 0 && practicesRequest.data?.data && practicesRequest.data.data.length > 0) {
      return practicesRequest.data.data.map(item => item.practice);
    }

    return [];
  }, [executionConfiguration, dsa, practicesRequest.data]);

  const rowData: PracticeRowData[] = useMemo(() =>
    practices.map((item) => ({
      id: item.cdb,
      name: item.name,
      cdb: item.cdb,
      included: item.counts && item.counts.included,
      excluded: item.counts && item.counts.excluded,
      population: item.counts && item.counts.population,
    })), [practices]);

  return (
    <div className="practices-table">
      <PracticeTable
        columns={columns}
        selectedRows={selectedRowIds as string[]}
        isLoading={practicesRequest.isLoading}
        isError={practicesRequest.isError}
        rowData={ rowData }
        isSelection={allowSelection}
        onSelectionChange={handleSelectionChange}
      />
    </div>
  );
};
